import { connect } from "react-redux"
import { compose } from "redux"
import StatisticsPageComparativeReport from '../components/statistics-page-comparative-report'
import { withTranslations } from "../decorators/with-translations"
import { setCrReportIds } from '../actions/survey'

const mapStateToProps = ({ survey: { crReportIds } }) => {
  return {
    crReportIds
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetCrReportIds: (crReportIds) => {
      dispatch(setCrReportIds(crReportIds));
    },
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps)
)(StatisticsPageComparativeReport)



// WEBPACK FOOTER //
// ./src/containers/statistics-page-comparative-report.js